import { Alert, Typography, styled } from '@mui/material'
import React from 'react'
import { IPatientVitalSignsResponse } from 'types/patient/types'

interface OutdatedAlertProps {
  vitalSigns: IPatientVitalSignsResponse
  isHDA?: boolean
}

const StyledAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: theme.palette.outdated.main,
  '.MuiAlert-message': {
    flex: 1
  }
}))

const OutdatedAlert: React.FC<OutdatedAlertProps> = ({ vitalSigns, isHDA }) => {
  if (!vitalSigns.outdated) {
    return <></>
  }

  // HDA clinical trial patients
  if (isHDA && vitalSigns.outdated_48) {
    return (
      <StyledAlert severity='warning'>
        <Typography>
          {vitalSigns.clinical_trial_message?.['active'] ||
            'Aviso: dados desatualizados'}
        </Typography>
      </StyledAlert>
    )
  }

  // Regular patients
  return (
    <Alert severity='warning'>{vitalSigns.outdated_professional_message}</Alert>
  )
}

export default OutdatedAlert
